import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB7GFPg8L-OHVY2bctaWHJLyO5m3QVImSA",
  authDomain: "ates-gozcusu-projesi.firebaseapp.com",
  projectId: "ates-gozcusu-projesi",
  storageBucket: "ates-gozcusu-projesi.firebasestorage.app",
  messagingSenderId: "724777964711",
  appId: "1:724777964711:web:95b0611f0b1308c7b87782",
  measurementId: "G-9QQV0T1MWD"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);